export const assignment_file_size = 11097152;
export const assignment_file_types = ['ppt','pptx','pdf', 'doc', 'docx'];
export const discussion_file_types = ["pdf", "docx", "ppt"]